module.exports = __webpack_public_path__ + "img/HONEY.c0aa9fac.png";